import React, { useMemo } from "react";
import { HiOutlineChip } from "react-icons/hi";
import {
  formatAudSmart,
  formatCount,
  truncateLabel,
} from "pages/ServiceProvider/SpSetting/AiCreditsUsage/aiUsageChartUtils";
import PlatformAiUsageBreakdownTrendChart from "./PlatformAiUsageBreakdownTrendChart";
import { mapByModelForChart } from "./aiUsageOverview.utils";

const PlatformAiUsageByModelChart = ({
  items = [],
  trends = [],
  loading = false,
  error = "",
  from,
  to,
  granularity = "day",
}) => {
  const mappedItems = useMemo(() => mapByModelForChart(items), [items]);

  const totals = useMemo(() => {
    const calls = mappedItems.reduce(
      (sum, row) => sum + (Number(row.call_count) || 0),
      0
    );
    const cost = mappedItems.reduce(
      (sum, row) => sum + (Number(row.cost_aud) || 0),
      0
    );
    return { calls, cost };
  }, [mappedItems]);

  const topModel = [...mappedItems].sort(
    (a, b) => (Number(b.cost_aud) || 0) - (Number(a.cost_aud) || 0)
  )[0];

  return (
    <PlatformAiUsageBreakdownTrendChart
      title="Spend by model"
      subtitle="AI credit cost by underlying LLM over time"
      icon={HiOutlineChip}
      iconClassName="bg-sky-50 text-sky-600"
      trends={trends}
      keyField="model"
      from={from}
      to={to}
      granularity={granularity}
      loading={loading}
      error={error}
      valueKey="cost_aud"
      labelFn={(key) => key}
      metricItems={
        mappedItems.length > 0
          ? [
              { label: "Total spend", value: formatAudSmart(totals.cost) },
              { label: "Total calls", value: formatCount(totals.calls) },
              {
                label: "Top model",
                value: topModel ? truncateLabel(topModel.label, 24) : "—",
              },
            ]
          : []
      }
      emptyTitle="No model usage"
      emptyHint="Model-level spend appears once AI calls are logged with a model name."
    />
  );
};

export default PlatformAiUsageByModelChart;
